// The Watchlist quick filter narrows the rows already in the browser; it never
// searches the security catalog the way the "+" dialog does.
import {
    securityCompanyName,
    securityCountry,
    securityListingMarket,
    securitySubmittedIdentifier,
    securityTickerPresentation,
} from '../../utils/securityIdentityPresentation';

// Lower case without accents, so "nestle" finds "Nestlé".
function searchableText(value) {
    return String(value ?? '')
        .normalize('NFD')
        .replace(/[̀-ͯ]/g, '')
        .toLowerCase();
}

export function watchlistSearchTerms(query) {
    return searchableText(query).split(/\s+/).filter(Boolean);
}

// Every name, ticker and identifier a row can show, whichever one the identity
// column displays, plus its country, listing market and attribute values.
export function watchlistRowSearchText(row, attributeValues = []) {
    return searchableText([
        securityCompanyName(row),
        row?.company_name,
        row?.yf_longname,
        row?.yf_shortname,
        securityTickerPresentation(row).value,
        row?.ticker,
        row?.yf_symbol,
        securitySubmittedIdentifier(row, { includeTickerType: true }),
        securityCountry(row),
        row?.country,
        securityListingMarket(row),
        ...attributeValues,
    ].filter((value) => value != null && value !== '').join('\n'));
}

// A row matches when every word of the query appears somewhere in it.
export function filterWatchlistRows(rows, query, attributeValuesForRow = () => []) {
    const terms = watchlistSearchTerms(query);
    if (terms.length === 0) return rows;
    return rows.filter((row) => {
        const text = watchlistRowSearchText(row, attributeValuesForRow(row));
        return terms.every((term) => text.includes(term));
    });
}
